import React, { Component } from 'react';
import axios from 'axios';
import { translate } from 'react-i18next';

import LogoPro from './../../images/pro.png';
import LogoStart from './../../images/start.png';
import LogoPlus from './../../images/plus.png';
import moment from 'moment-timezone';

import Coworkimg from './../../images/cowork.png';

let cancelToken;
let state;
let tokenSession;

class CoworkContainer extends Component {
    getInitState = () => {
        return {
            cowork: null,
            centros: [],
        }
    }

    constructor(props) {
        super(props);
        if (tokenSession !== props.getTokenSession()) {
            state = this.getInitState();
        }
        this.state = state;
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    componentDidMount() {
        this.reload();
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        state = this.state;
        tokenSession = this.props.getTokenSession();
    }

    reload = () => {
        this.getcowork({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
        })
    }

    getcowork = (params) => {
        this.props.post(
            "/getcowork",
            params,
            (response) => this.didGetCowork(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    getCentrosByCategoria = (params) => {
        this.props.post(
            "/getCentrosByCategoria",
            params,
            (response) => this.didGetCenter(response),
            (error) => this.handleErrorResponse(error),
            cancelToken
        );
    }

    didGetCowork = (response) => {
        this.setState({
            cowork: response
        })

        this.getCentrosByCategoria({
            token_id: this.props.getTokenId(),
            token_session: this.props.getTokenSession(),
            zona_id: response.zone_id,
            categoria_center: response.plan_cowork
        })
    }

    didGetCenter = (response) => {
        this.setState({
            centros: response,
        })
    }

    handleErrorResponse = (error) => {
    }

    render() {
        const { t } = this.props;
        const cowork = this.state.cowork
        const centros = this.state.centros
        let LogoPlan  = null;
        let ColorPlan = null;


        const start_day = cowork ? moment(cowork.fecha_inicio).format("DD-MM-YYYY") : null
        const finsh_day = cowork ? moment(cowork.fecha_fin).format("DD-MM-YYYY") : null

        if(this.state.cowork) {
            LogoPlan = this.state.cowork.plan_cowork == "Pro" ? LogoPro : LogoPlus
            ColorPlan = this.state.cowork.plan_cowork == "Pro" ? "text-warning" : "text-info"
        } 

        return (
            <div className="content-cowork">
                <div className="container-cowork-title">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="page-header">{t('dashboard.history.Cowork.cowork')}</h2>
                        </div>
                    </div>
                </div>
                {this.state.cowork ? (
                    <div>
                        <div className="container-cowork">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 card-panel-cowork">
                                <div className="card-panel panel panel-default card">
                                    <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + Coworkimg + "')" }}>
                                    </div>
                                    <div className="card-panel-body">
                                        <div className="panel-body-title">
                                            <h4 className="ioscentro">
                                                {cowork.centro_name}
                                            </h4>
                                        </div>
                                        <div className="panel-body-description">
                                            <div className="panel-description-text">
                                                <div className="col-xl-4 col-lg-4 col-md-6 hidden-xs hidden-sm col-sm-12 col-12">
                                                    <h4 className="page-header" style={{ "paddingInline": "60px" }}>
                                                        {cowork.plan_cowork == "Plus" || cowork.plan_cowork == "Pro" ? (
                                                            <img className="hidden-xs hidden-sm" alt="IOS OFFICES" src={LogoPlan} height="100px" />
                                                        ) : null}
                                                    </h4>
                                                </div>
                                                <div className="col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12">
                                                    <div className="form-group">
                                                        <h3 className={cowork.plan_cowork == "Plus" || cowork.plan_cowork == "Pro" ? ColorPlan : "text-primary"}>
                                                            Tipo  de plan: {cowork.plan_cowork}
                                                        </h3>
                                                        <p
                                                            className="bg-primary btn-secondary">
                                                            FECHA DE INICIO: {start_day}
                                                        </p>
                                                        <p className="bg-primary btn-secondary" >
                                                            FECHA DE FINAL: {finsh_day}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="panel-body-bottom">
                                            <div className="form-group">
                                                <button
                                                    className="btn btn-block btn-primary btn-secondary"
                                                    type="button">
                                                    Duracion de Reservacion: {cowork.tipo_reservacion}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-cowork-description">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 card-panel-cowork">
                                <div className="col-md-6">
                                    <h4 className="page-header text-primary">
                                        <strong>{t('dashboard.reservations.heading_included')}</strong>
                                    </h4>
                                    {cowork.servicios_incluidos ? (
                                        cowork.servicios_incluidos.map((name, index) => (
                                            <p className="text-description" key={index}>
                                                {name.name}
                                            </p>
                                        ))
                                    ) : null}
                                </div>
                                <div className="col-md-6">
                                    <h4 className="page-header text-primary">
                                        <strong>{t('dashboard.reservations.heading_extras')}</strong>
                                    </h4>
                                    {cowork.servicios_adicionales ? (
                                        cowork.servicios_adicionales.map((name, index) => (
                                            <p className="text-description" key={index}>
                                                {name.name}
                                            </p>
                                        ))
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        <div className="container-cowork-direction">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 card-panel-cowork">
                                <h4 className="page-header text-primary">
                                    <strong>{t('guest.benefits.LearnMore')}
                                    </strong>
                                </h4>
                                <div className="list-card-resvations">
                                    <div className="list-card-panel-seccion">
                                        <div className="content-card-panel-seccion">
                                            <div className="list list-actaul">
                                                {centros.map((centros, index) => (
                                                    <div className="col-lg-12 col-md-12 col-sm-12 col-12 card-panel-rooms" key={index}>
                                                        <div className="card-panel panel panel-default card-panel-history">
                                                            <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + Coworkimg + "')" }}>
                                                            </div>
                                                            <div className="card-panel-body">
                                                                <div className="panel-body-title">
                                                                    <h4 className="ioscentro">{centros.name.toUpperCase()}</h4>
                                                                </div>
                                                                <div className="panel-body-description">
                                                                    <div className="panel-description-information">
                                                                        <div className="contenedor-flexbox">
                                                                        </div>
                                                                        <div className="contenedor-flexbox">
                                                                            <div className="contenedor">
                                                                                {centros.address},
                                                                                <br></br>
                                                                                {centros.city},
                                                                                <br></br>
                                                                                {centros.estado}, {centros.cp}
                                                                            </div>
                                                                        </div>
                                                                        <br></br>
                                                                        <br></br>
                                                                        <div className="contenedor-flexbox">
                                                                            <div className="contenedor">
                                                                                Hora de Apertura :{centros.Hora_inicio}
                                                                                <br></br>
                                                                                Hora de Cierre : {centros.Hora_final}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)
                    : ( 
                    <h2 className="page-header">
                        {t('dashboard.history.no_results')}
                    </h2>
                    )}
            </div>
        );
    }
}
export default translate('common')(CoworkContainer);


// WEBPACK FOOTER //
// ./src/dashboard/cowork/CoworkContainer.js